// atomic.text-input.v1
// atomic.textarea.v1
//
// Wraps the existing TextField with a registry-shape API. multiline=true
// renders as textarea (TextField supports that natively).

import type { ComponentProps } from "solid-js"
import { TextField } from "../../components/text-field"

type Base = ComponentProps<typeof TextField>

export interface RegistryTextInputProps
  extends Omit<Base, "multiline" | "variant"> {
  appearance?: "normal" | "ghost"
}

export function TextInput(props: RegistryTextInputProps) {
  const { appearance, ...rest } = props
  return (
    <TextField
      data-registry-id="atomic.text-input"
      variant={appearance ?? "normal"}
      {...rest}
    />
  )
}

export interface RegistryTextareaProps
  extends Omit<Base, "multiline" | "variant"> {
  appearance?: "normal" | "ghost"
}

export function Textarea(props: RegistryTextareaProps) {
  const { appearance, ...rest } = props
  return (
    <TextField
      data-registry-id="atomic.textarea"
      multiline
      variant={appearance ?? "normal"}
      {...rest}
    />
  )
}
